import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  forwardRef,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Navigation } from "../../../model/navigation";
import { SingleChoice } from "../../../model/singlechoice";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, Observer } from "rxjs";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { TicketService } from "../../../services/ticket.service";
import { NavigationHelper } from "../../../services/navigation.helper";
import { Labeler } from "../../../model/labeler";

@Component({
  selector: "single-choice",
  templateUrl: "./singlechoice.component.html",
  styleUrls: ["./singlechoice.component.css"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SingleChoiceComponent),
      multi: true,
    },
  ],
})
export class SingleChoiceComponent implements OnInit, ControlValueAccessor {
  @Output() choiceEvent: EventEmitter<SingleChoice> = new EventEmitter();
  @Output() choice: EventEmitter<number> = new EventEmitter();
  @Input() topic: string;
  @Input() label: string;
  @Input() editMode: boolean;
  @Input() ticketId: number | null;
  @Input() currentDepartmentId: number | null;
  @Input() completedUrl: Observable<string>;
  @Input() icon!: string;
  @Input() choiceObserver: Partial<Observer<number>>;
  @Input() labeler: Observable<string>;
  @Input() labelOnDemand: Labeler;
  currentbackgroundColor = new BehaviorSubject<string>("#ccc");
  currentcolor = new BehaviorSubject<string>("#555");
  selectedId: number;
  currentLabel = new BehaviorSubject<string>("");
  selectedCompletedUrl: string;
  selectedChoice: SingleChoice;
  status: number = 0;
  disabled: boolean = false;
  selecteLabel: string = "";
  constructor(
    private translate: TranslateService,
    private router: Router,
    private ticket: TicketService,
    private nav: NavigationHelper
  ) {}

  ngOnInit() {
    if (!this.icon) {
      switch (this.topic) {
        case "status":
          this.icon = "check_circle";
          break;
        case "users":
          this.icon = "person";
          break;
        case "priority":
          this.icon = "error-circle";
          break;
        case "branches":
          this.icon = "business";
          break;
        case "departments":
          this.icon = "apartment";
          break;
        case "multi-action":
          this.icon = "low_priority";
          break;
        default:
          this.icon = "help_outline";
      }
    }
    if (this.labeler) {
      this.labeler.subscribe((label) => {
        this.currentLabel.next(label);
      });
    } else {
      this.currentLabel.next(this.label);
    }
    if (this.completedUrl) {
      this.completedUrl.subscribe((url) => (this.selectedCompletedUrl = url));
    } else {
      this.selectedCompletedUrl = "";
    }

    this.labelOnDemand.makeColor(this.selectedId as number).subscribe((c) => {
      if (c && c.trim().length > 0) {
        this.currentcolor.next(c);
      }
    });
    this.labelOnDemand
      .makeBackgroundColor(this.selectedId as number)
      .subscribe((bc) => {
        if (bc && bc.trim().length > 0) {
          this.currentbackgroundColor.next(bc);
        }
      });
  }

  onClickChoice() {
    this.choiceObserver;

    const callback = this.choiceObserver;

    if (
      this.editMode &&
      this.ticketId &&
      (this.ticketId > 0 || this.ticketId === Navigation.NEW)
    ) {
      const safeTicketId = this.ticketId;

      this.status = 1;
      this.selectedChoice = new SingleChoice(this.topic);

      this.selectedChoice.setup().subscribe({
        next: (value) => {
          this.selectedId = value;
         
          this.currentLabel.next(this.selectedChoice.label);
          this.currentbackgroundColor.next(this.selectedChoice.backgroundColor);
          this.currentcolor.next(this.selectedChoice.color);

          this.status = 2;

          this.onChange(this.selectedId);

          var url = this.selectedCompletedUrl;
          if (
            !this.selectedCompletedUrl ||
            this.selectedCompletedUrl.length === 0
          ) {
            url = `tickets/${safeTicketId}/edit`;
          }

          this.router.navigate([url]).then(() => {
            this.choice?.emit(this.selectedId);

            this.nav.freshNavigation;
            this.choiceObserver?.next?.(value);
          });
        },
      });

      this.choiceEvent.emit(this.selectedChoice);

      this.router
        .navigate([`tickets/${this.ticketId}/choose/${this.topic}`])
        .then(() => {
          this.status = 2;
          this.nav.freshNavigation;
        });
    } else {
    }
  }

  onChange = (id: number) => {};

  onTouched = () => {};

  writeValue(id: number): void {
    this.selectedId = id;

    if (this.labelOnDemand) {
      this.labelOnDemand.makeLabel(id).subscribe((l) => {
        if (l && l.trim().length > 0) {
          this.currentLabel.next(l);
        }
      });

      this.labelOnDemand.makeColor(id).subscribe((c) => {
        if (c && c.trim().length > 0) {
          this.currentcolor.next(c);
        }
      });

      this.labelOnDemand.makeBackgroundColor(id).subscribe((bc) => {
        if (bc && bc.trim().length > 0) {
          this.currentbackgroundColor.next(bc);
        }
      });
    }
  }

  registerOnChange(fn: (id: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  get selectedLabel(): Observable<string> {
    return this.currentLabel;
  }
}
